import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { mergeRight } from 'ramda';

import setting from '../../setting';

const css = require('./popup-mini.css').default;

export default function ({ data, source, onClose }: {
    data: string,
    source: viewport,
    onClose: () => void,
}) {
    const [stage, setStage] = useState<'unmount' | 'mounted'>('unmount');
    const main = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setStage('mounted');
    }, []);

    const unmount: React.CSSProperties = {
        opacity: 0,
    }

    const mounted: React.CSSProperties = {
        opacity: 1,
    }

    const position: React.CSSProperties = {
        left: `${calcLeft(source.x, main.current?.offsetWidth || 0)}px`,
        bottom: `${window.innerHeight - source.y + 3}px`,
    }

    const style = mergeRight(stage === 'unmount' ? unmount : mounted, position);

    return (
    <div ref={main} id={css.main} style={style}>
        <div>{(() => {
            if (data.startsWith('text:')) {
                return data.replace(/^text:/, '');
            } else {
                return <img src={`${setting.bookDir}/補充資料/${data.replace(/^image:/, '')}`}/>;
            }
        })()}</div>
        <Close style={{ width: '30px', height: '30px', cursor: 'pointer' }} onClick={onClose}/>
    </div>);
}

function Close({ style, onClick }: {
    style: React.CSSProperties,
    onClick: () => void,
}) {
    return (
    <svg xmlns="http://www.w3.org/2000/svg" style={style} fill="#444" viewBox="0 0 16 16"
        onClick={onClick}
    >
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
    </svg>);
}

function calcLeft(sourceX: number, width: number) {
    if (sourceX < 0) {
        return 1;
    } else if (sourceX + width > window.innerWidth) {
        return window.innerWidth - width - 15;
    } else {
        return sourceX;
    }
}

type size = {
    width: number,
    height: number,
}

type offset = {
    x: number,
    y: number,
}

type position = offset;
type viewport = size & position;
